import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const MatchIndicator = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${Spacing.S8};
`

interface ReconciliationSuggestionContentProps {
  linePosition: 'left' | 'right'
}

export const ReconciliationSuggestionContent = styled.div<ReconciliationSuggestionContentProps>`
  display: grid;
  align-items: center;
  grid-template-columns: ${({ linePosition }) => (linePosition === 'left' ? 'auto min-content' : 'min-content auto')};
  grid-gap: ${Spacing.S8};
`
